<template>
    <v-container>
        <div class="d-flex align-center mb-6">
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="請輸入群組名稱來搜尋" outlined dense
                hide-details class="flex-grow-1 mr-4"></v-text-field>

            <v-select v-model="filterSelect" :items="filterSelectItems" label="過濾狀態" outlined dense hide-details
                class="mr-4 filterSelect"></v-select>

            <v-btn color="black" dark @click="addGroup">
                新增群組
            </v-btn>
        </div>

        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>群組名稱</th>
                        <th>人數</th>
                        <th>狀態</th>
                        <th class="text-right">操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="group in filteredGroups" :key="group._id">
                        <td class="text-left">{{ group.name }}</td>
                        <td class="text-left">{{ group.count }}</td>
                        <td class="text-left">
                            <v-switch dense v-model="group.status"
                                @change="updateGroupStatus(group._id, $event)"></v-switch>
                        </td>
                        <td class="text-right">
                            <v-icon small class="mr-2" @click="editGroup(group)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="deleteGroup(group)">
                                mdi-delete
                            </v-icon>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-dialog v-model="dialog" max-width="800px">
            <v-card>

                <v-stepper v-model="step" width="100%">
                    <v-stepper-header style="justify-content: center;">
                        <v-stepper-step :complete="step > 1" step="1" color="black">
                            輸入群組名稱
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2" color="black">
                            選擇學生
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-card-title class="editGroupTitle" style="justify-content: center;">
                        {{ isEditing ? '編輯群組' : '新增群組' }}
                    </v-card-title>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card-text>
                                <v-text-field v-model="newGroupName" label="群組名稱" outlined></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="black" dark @click="step = 2">下一步</v-btn>
                            </v-card-actions>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card-text>
                                <v-text-field v-model="studentSearch" prepend-inner-icon="mdi-magnify"
                                    placeholder="請輸入姓名或班級或學生資料" outlined dense hide-details></v-text-field>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>選擇</th>
                                                <th>系別</th>
                                                <th>年級</th>
                                                <th>班級</th>
                                                <th>姓名</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="student in filteredStudents" :key="student._id">
                                                <td>
                                                    <v-checkbox v-model="selectedStudents"
                                                        :value="student._id" color="black"></v-checkbox>
                                                </td>
                                                <td class="text-left">{{ student.department ? student.department.name : '未分類' }}</td>
                                                <td class="text-left">{{ student.classYear ? student.classYear.name : '未分類' }}</td>
                                                <td class="text-left">{{ student.classGroup ? student.classGroup.name : '未分類' }}</td>
                                                <td class="text-left">{{ student.name || '' }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn text @click="step = 1">返回</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="black" dark @click="confirmGroup">確定</v-btn>
                            </v-card-actions>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card>
        </v-dialog>

        <!-- 添加確認刪除對話框 -->
        <v-dialog v-model="deleteDialog" max-width="400">
            <v-card>
                <v-card-title class="headline">確認刪除</v-card-title>
                <v-card-text>
                    確定要刪除「{{ selectedGroup?.name }}」群組嗎？此操作無法復原。
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="deleteDialog = false">取消</v-btn>
                    <v-btn color="red darken-1" text @click="confirmDelete">確定刪除</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>

<script>
import StudentGroupService from '../../services/studentGroup.service';
import UserService from '../../services/user.service';
export default {
    data() {
        return {
            search: '',
            filterSelect: '',
            filterSelectItems: ['啟用', '關閉'],
            groups: [],
            dialog: false,
            step: 1,
            newGroupName: '',
            studentSearch: '',
            selectedStudents: [],
            students: [],
            deleteDialog: false,
            selectedGroup: null,  // 用於存儲要刪除的群組
            isEditing: false,  // 用來判斷是新增還是編輯模式
            editingGroupId: null,  // 儲存正在編輯的群組ID
        }
    },

    computed: {
        filteredGroups() {
            let filtered = this.groups;
            
            // 先根據搜尋字串過濾
            if (this.search) {
                const searchTerm = this.search.toLowerCase();
                filtered = filtered.filter(group => 
                    group.name.toLowerCase().includes(searchTerm)
                );
            }
            
            // 再根據狀態過濾
            if (this.filterSelect) {
                filtered = filtered.filter(group => {
                    if (this.filterSelect === '啟用') {
                        return group.status === true;
                    } else if (this.filterSelect === '關閉') {
                        return group.status === false;
                    }
                    return true;
                });
            }
            
            return filtered;
        },
        
        filteredStudents() {
            if (!this.studentSearch) return this.students;

            const search = this.studentSearch.toLowerCase();
            return this.students.filter(student =>
                (student.name || '').toLowerCase().includes(search) ||
                (student.department?.name || '').toLowerCase().includes(search) ||
                (student.classYear?.name || '').toLowerCase().includes(search) ||
                (student.classGroup?.name || '').toLowerCase().includes(search)
            );
        }
    },
    async mounted() {
        await this.getGroupByTeacher();
        await this.getStudentBySchool();
    },
    methods: {
        getGroupByTeacher(){
            StudentGroupService.getGroupByTeacher().then((res) => {
                this.groups = res.data;
            });
        },
        getStudentBySchool(){
            UserService.getStudentBySchool().then((res) => {
                res.data.forEach(students => {
                    students.students.forEach(student => {
                        this.students.push(student);
                    });
                });
            });
        },
        // 開啟新增群組對話框
        addGroup() {
            this.isEditing = false;
            this.dialog = true;
            this.step = 1;
            this.newGroupName = '';
            this.selectedStudents = [];
            this.studentSearch = '';
        },

        // 開啟編輯群組對話框
        async editGroup(group) {
            this.isEditing = true;
            this.editingGroupId = group._id;
            this.newGroupName = group.name;
            group.students.forEach(student => {
                this.selectedStudents.push(student._id);
            });
            this.dialog = true;
            this.step = 1;
            this.studentSearch = '';
        },

        // 確認建立或更新群組
        async confirmGroup() {
            if (!this.newGroupName) {
                alert('請輸入群組名稱');
                return;
            }

            if (this.selectedStudents.length === 0) {
                alert('請選擇至少一位學生');
                return;
            }

            try {
                const groupData = {
                    name: this.newGroupName,
                    studentIds: this.selectedStudents
                };
                console.log(groupData);

                if (this.isEditing) {
                    // 更新群組
                    // await this.$axios.put(`/api/groups/${this.editingGroupId}`, groupData);
                    StudentGroupService.update({_id: this.editingGroupId ,...groupData}).then(() => {
                        this.getGroupByTeacher();
                    });
                } else {
                    // 新增群組
                    StudentGroupService.add(groupData).then(() => {
                        this.getGroupByTeacher();
                    });
                }

                this.dialog = false;
                this.resetForm();
            } catch (error) {
                console.error(this.isEditing ? '更新群組失敗:' : '建立群組失敗:', error);
            }
        },

        // 重置表單
        resetForm() {
            this.isEditing = false;
            this.editingGroupId = null;
            this.newGroupName = '';
            this.selectedStudents = [];
            this.studentSearch = '';
            this.step = 1;
        },

        // 更新群組狀態
        async updateGroupStatus(groupId, status) {
            try {
                console.log(groupId ,status);
                StudentGroupService.update({_id: groupId ,status: status}).then(() => {
                    this.getGroupByTeacher();
                });
            } catch (error) {
                console.error('更新群組狀態失敗:', error);
            }
        },


        // 開啟刪除確認對話框
        deleteGroup(group) {
            this.selectedGroup = group;
            this.deleteDialog = true;
        },

        // 確認刪除
        async confirmDelete() {
            try {
                StudentGroupService.delete(this.selectedGroup._id).then(() => {
                    this.getGroupByTeacher();
                });
                this.deleteDialog = false;
                this.selectedGroup = null;
            } catch (error) {
                console.error('刪除群組失敗:', error);
            }
        },
    }
}
</script>

<style>
.filterSelect {
    width: 100px;
}

.editGroupTitle {
    color: #000;
font-family: "Noto Sans CJK TC";
font-size: 32px;
font-style: normal;
font-weight: 700;
line-height: normal;
}
</style>